module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dm8Lo"))).then(() => parcelRequire('ljYL6'));